<template>
    <div class="popover-wrapper" ref='pop' :class="{show: show}" :style="{display: display ?'block':'none'}">
        <slot></slot>
    </div>
</template>

<script>
    import service from '../assets/js/service'
    export default {
        name: "popover",
        data: () => ({
            display: false
        }),
        props: {
            show: {
                default: true,
                type: Boolean
            }
        },
        watch: {
            show: {
                handler(val) {
                    if (val) {
                        this.display = true
                    } else {
                        // this.$refs.pop && this.$refs.pop.addEventListener('transitionend', () => {
                        //     this.display = false
                        // });
                        setTimeout(_=>{
                            this.display = false
                        },500)
                    }
                },
                immediate: true
            }
        }
    };
</script>

<style scoped>
    .popover-wrapper {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .3);
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.5s;
    }

    .popover-wrapper.show {
        opacity: 1;
    }
</style>